// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__gZHsR"};